import React, { Component } from 'react';
import {
    Form, Button, Input, Select,
} from 'antd';
import { connect } from 'react-redux';
import axios from 'axios';

import { SET_REFILLS } from '../../ActionTypes/ActionTypes';

const FormItem = Form.Item;
const { Option } = Select;

class UnwrappedSearchForm extends Component {
    state = {
        partnersList: [],
        locationsList: [],
    }

    componentDidMount = () => {
        this.fetchPartners();
    }

    fetchPartners = () => {
        this.setState({ loading: true });
        axios({
            method: 'get',
            url: '/partners.json',
            headers: { Authorization: sessionStorage.getItem('jwtToken') },
        })
            .then((response) => {
                // console.log(response.data);
                this.setState({ partnersList: response.data });
            })
            .catch((error) => {
                alert(`Internet Not working, Please check you connection: ${error.code}`);
            });
        this.setState({ loading: false });
    }

    handlePartnerChange = (value) => {
        const { partnersList } = this.state;
        const locations = partnersList.filter(p => p.id === Number(value));
        this.setState({ locationsList: locations[0].partner_locations });
    }

    handleSubmit = (event) => {
        // console.log(this.props.refillsList);
        const { refillsList, setRefills } = this.props;
        const { form } = this.props;
        event.preventDefault();


        form.validateFields((err, values) => {
            if (!err) {
                values.location = values.location == null ? '' : values.location;
                values.name = values.name == null ? '' : values.name;
                values.mobile_number = values.mobile_number == null ? '' : values.mobile_number;

                const updatedRefill = refillsList.filter(
                    refill => new RegExp(values.name, 'i').test(refill.patient_name)
                        && new RegExp(values.location).test(refill.location)
                        && new RegExp(values.mobile_number).test(refill.mobile_number),
                );

                setRefills(updatedRefill);
            }
        });
    }

    render() {
        const { form } = this.props;
        const { getFieldDecorator } = form;
        const { partnersList, locationsList } = this.state;

        const partnersOption = partnersList.map(
            partner => (
                <Option key={partner.id}>
                    {partner.name}
                </Option>
            ),
        );

        const locationsOption = locationsList.map(
            location => (
                <Option key={location.name}>
                    {location.name}
                </Option>
            ),
        );

        return (
            <Form layout="inline" onSubmit={this.handleSubmit}>

                <FormItem>
                    {getFieldDecorator('partner', {
                        rules: [{ required: false, message: 'Please input your username!' }],
                    })(
                        <Select placeholder="Partner" style={{ width: 180 }} onChange={this.handlePartnerChange}>
                            {partnersOption}
                        </Select>,
                    )}
                </FormItem>

                <FormItem>
                    {getFieldDecorator('location', {
                        rules: [{ required: false, message: 'Please input your Password!' }],
                    })(
                        <Select placeholder="Location" style={{ width: 180 }}>
                            {locationsOption}
                        </Select>,
                    )}
                </FormItem>

                <FormItem>
                    {getFieldDecorator('name', {
                        rules: [{ required: false, message: 'Please input your Password!' }],
                    })(
                        <Input placeholder="Name" />,
                    )}
                </FormItem>

                <FormItem>
                    {getFieldDecorator('mobile_number', {
                        rules: [{ required: false, message: 'Please input your Password!' }],
                    })(
                        <Input placeholder="Mobile" />,
                    )}
                </FormItem>

                <FormItem>
                    <Button
                        type="primary"
                        htmlType="submit"
                    >
                        Apply
                    </Button>
                </FormItem>
            </Form>
        );
    }
}

const mapStateToProps = state => ({
    refillsList: state.RefillState.refillsList,
});

const mapDispatchToProps = dispatch => ({
    setRefills: data => dispatch({ type: SET_REFILLS, payload: { data } }),
});

const SearchForm = Form.create()(UnwrappedSearchForm);

export default connect(mapStateToProps, mapDispatchToProps)(SearchForm);



// WEBPACK FOOTER //
// ./src/component/RefillManagementSystem/SearchForm.js